import React from "react";
import { Modal, Form } from "antd";
import { DatePickerField, InputField } from "../../../blueplanitUtils/InputField";
import dayjs from "dayjs";
import moment from "moment";



export const handleExport = (fileFormat, selectedColumns, data, pagination) => {
  if (!data || data.length === 0) {
    window?.message?.info?.("No data available for export.");
    return;
  }

  const dataToExport = data.map((row, index) => ({
    ...row,
    sno: (pagination.current - 1) * pagination.pageSize + index + 1,
    purchaseDate: row.purchaseDate
      ? dayjs(Number(row.purchaseDate)).isValid()
        ? dayjs(Number(row.purchaseDate)).format("DD/MM/YYYY")
        : ""
      : "",
  }));

  if (fileFormat === "CSV") {
    const csvData = convertToCSV(dataToExport, selectedColumns);
    downloadCSV(csvData, "Assets_Report.csv");
  } else if (fileFormat === "PDF") {
    simulatePrintDialog(dataToExport, selectedColumns);
  }
};

const convertToCSV = (data, selectedColumns) => {
  const headers = selectedColumns.join(",") + "\n";
  const rows = data.map((row) =>
    selectedColumns.map((col) => `"${row[col] ?? ""}"`).join(",")
  );
  return headers + rows.join("\n");
};

const downloadCSV = (csv, filename) => {
  const blob = new Blob([csv], { type: "text/csv" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const simulatePrintDialog = (dataToExport, selectedColumns) => {
  const printableContent = document.createElement("div");
  printableContent.id = "print-content";

  const table = document.createElement("table");
  table.style.width = "100%";
  table.style.border = "1px solid #000";
  table.style.borderCollapse = "collapse";

  const thead = document.createElement("thead");
  const headerRow = document.createElement("tr");

  selectedColumns.forEach((col) => {
    const th = document.createElement("th");
    th.innerText = col;
    th.style.border = "1px solid #000";
    th.style.padding = "5px";
    headerRow.appendChild(th);
  });
  thead.appendChild(headerRow);
  table.appendChild(thead);

  const tbody = document.createElement("tbody");
  dataToExport.forEach((row) => {
    const tr = document.createElement("tr");
    selectedColumns.forEach((col) => {
      const td = document.createElement("td");
      td.innerText = row[col] || "";
      td.style.border = "1px solid #ccc";
      td.style.padding = "5px";
      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  });

  table.appendChild(tbody);
  printableContent.appendChild(table);

  const style = document.createElement("style");
  style.innerHTML = `
    body * { visibility: hidden; }
    #print-content, #print-content * { visibility: visible; }
    #print-content { position: absolute; top: 0; left: 0; width: 100%; }
  `;
  document.head.appendChild(style);
  document.body.appendChild(printableContent);
  window.print();
  document.body.removeChild(printableContent);
  document.head.removeChild(style);
};



const AssetCheckInOutModal = ({
  isCheckOutModalOpen,
  setIsCheckOutModalOpen,
  selectedAssetForCheckout,
  checkoutForm,
  loginUser,
  dispatch,
  checkoutAsset,
  AllAssets,
  getAllAssets,
  pagination,
  filters,
  message,
}) => (
  <Modal
    title={`Check Out Asset - ${selectedAssetForCheckout?.assetTagId || ""}`}
    open={isCheckOutModalOpen}
    onCancel={() => setIsCheckOutModalOpen(false)}
    onOk={() => {
      checkoutForm.validateFields().then(async (values) => {
        try {
          const expectedCheckInDate = values.expectedCheckInDate
            ? dayjs(values.expectedCheckInDate).valueOf().toString()
            : null;

          const checkOutDate = values.checkOutDate
            ? dayjs(values.checkOutDate).valueOf().toString()
            : dayjs().valueOf().toString();

          await dispatch(
            checkoutAsset({
              id: selectedAssetForCheckout.id,
              checkedOutBy: `${loginUser.firstname} ${loginUser.lastname}`,
              checkOutReason: values.checkOutReason,
              expectedCheckInDate,
              checkOutDate,
            })
          ).unwrap();

          dispatch(getAllAssets({
            page: pagination.current,
            pageSize: pagination.pageSize,
            ...filters,
          }));
          message.success("Asset Checked Out!");

          setIsCheckOutModalOpen(false);
          checkoutForm.resetFields();
        } catch (error) {
          message.error(error || "Checkout failed");
        }
      });
    }}
    okText="Check Out"
  >
    <Form form={checkoutForm} layout="vertical">
      <Form.Item
        name="checkOutDate"
        label="Check-Out Date"
        rules={[
          { required: true, message: "Please select check-out date" },
        ]}
      >
        <DatePickerField
          style={{ width: "100%" }}
          format="DD/MM/YYYY"
          disabledDate={(current) =>
            current && current > moment().endOf("day")
          }
        />
      </Form.Item>

      <Form.Item
        name="checkedOutBy"
        label="Checked Out By"
        rules={[{ required: true, message: "Checked Out By is required" }]}
      >
        <InputField disabled />
      </Form.Item>

      <Form.Item
        name="checkOutReason"
        label="Reason for Check-Out"
        rules={[{ required: true, message: "Please enter a reason" }]}
      >
        <InputField placeholder="Enter reason for check out" />
      </Form.Item>
      <Form.Item
        name="expectedCheckInDate"
        label="Expected Check-In Date"
        rules={[
          {
            required: true,
            message: "Please select expected check-in date",
          },
        ]}
      >
        <DatePickerField style={{ width: "100%" }} format="DD/MM/YYYY" disabledDate={(current) => current && current < moment().startOf("day")} />
      </Form.Item>
    </Form>
  </Modal>
);

export default AssetCheckInOutModal;